enum MileageAddViewMode {
  CARGO = "CARGO",
  RAILY = "RAILY",
}

export default MileageAddViewMode;
